import {graphql} from 'react-relay';
import {fetchQuery} from 'relay-runtime';
import RelayEnvironment from '../../RelayEnvironment';
import {isTicketingAvailable} from '../../forecast-app/shared/util/ticketingAvailability';
import {hasPermission} from '../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../Permissions';

const PrefsQuery = graphql`
	query fetchTicketNotificationPrefsQuery {
		viewer {
			ticketingNotificationPrefs {
				emailAssigned
				emailMentioned
				emailCustomerReplied
				emailWatching
				emailSlaBreached
				inAppAssigned
				inAppMentioned
				inAppCustomerReplied
				inAppWatching
				inAppSlaBreached
			}
		}
	}
`;

/**
 * Returns the ticket notification prefs, or null when the viewer lacks ticketing
 * access. The `ticketingNotificationPrefs` field is TICKETS_VIEW-guarded and would
 * FORBIDDEN-error for non-ticketing users, so we gate the query behind the same
 * module + permission check rather than selecting it in an always-on fragment.
 */
export async function fetchTicketNotificationPrefs(): Promise<Record<string, boolean> | null> {
	try {
		if (!(isTicketingAvailable() && hasPermission(PERMISSION_TYPE.TICKETS_VIEW))) {
			return null;
		}
	} catch {
		return null;
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const data: any = await fetchQuery(RelayEnvironment.getInstance(), PrefsQuery, {}).toPromise();
	return data?.viewer?.ticketingNotificationPrefs ?? null;
}
